<template>
    <rkm-modal
        extra-large
        hide-footer
        ref="RkmModal"
        title="Registro retroativo"
    >
        <rkm-alert
            v-if="!model.data"
            color="info"
        >
            Informe uma data para visualizar os agendamentos.
        </rkm-alert>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-date-picker
                    :max-date="maxDate"
                    :validations="validations.data"
                    label="Data"
                    v-model="model.data"
                />
            </rkm-col>
        </rkm-row>

        <rkm-table
            :fields="fields"
            :items="agendamentos"
        >
            <template v-slot:cell(pacienteNome)="{index, item}">
                <template v-if="item.pacienteNome">
                    <rkm-button
                        :id="uniqueId(`paciente-icon-${index}`)"
                        class="mr-2"
                        small
                    >
                        <rkm-icon icon="user" />
                    </rkm-button>

                    <rkm-popover
                        :target="uniqueId(`paciente-icon-${index}`)"
                        placement="top"
                        title="Dados cadastrais"
                        triggers="hover"
                    >
                        <div>
                            <span>
                                <strong>Data de nascimento:</strong> {{item.pacienteDataNascimento}}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>Nome da mãe:</strong> {{item.pacienteNomeMae}}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>CPF:</strong> {{item.pacienteCpf}}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>CNS:</strong> {{item.pacienteCns}}
                            </span>
                        </div>
                    </rkm-popover>

                    <template>
                        {{item.pacienteNome}}

                        <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                            <strong>
                                ({{item.pacienteNomeSocial}})
                            </strong>
                        </template>
                    </template>
                </template>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="create(item.id)"
                    color="primary"
                    small
                    title="Atender"
                >
                    <rkm-icon icon="plus" />
                </rkm-button>
            </template>
        </rkm-table>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Others.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        maxDate() {
            return this.others.moment(this.dataAtual, 'DD/MM/YYYY').subtract(1, 'days').format('DD/MM/YYYY')
        },
        validations() {
            return {
                data: {required: true}
            }
        }
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('ambulatorio.fila'),
        }
    },
    data: () => ({
        model: {
            data: null,
        },
        enums: {preferenciaNome},
        others: {moment},
        fields: [
            {key: 'horario', label: 'Horário', sortable: true},
            {key: 'pacienteNome', label: 'Nome', sortable: true},
            {key: 'pacienteIdade', label: 'Idade', sortable: true},
            {key: 'pacienteProntuario', label: 'Prontuário', sortable: true},
            {key: 'especialidadeNome', label: 'Especialidade', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        agendamentos: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.model.data = null
            this.agendamentos = []

            this.$refs.RkmModal.show()
        },
        loadAgendamentos() {
            this.setLoading()

            this.repositories.fila.getAgendamentosRetroativos({
                data: this.others.moment(this.model.data).format('DD/MM/YYYY')
            })
                .then(({data}) => this.agendamentos = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        create(agendamentoId) {
            if (this.origem === 'atendimento') {
                this.$router.push({name: 'ambulatorio-atendimento-create', params: {filaId: 0, agendamentoId}})
            }
            else if (this.origem === 'enfermagem') {
                this.$router.push({
                    name: 'ambulatorio-atendimento-enfermagem-create',
                    params: {tipoAtendimento: 'enfermagem', filaId: 0, agendamentoId}
                })
            }
        },
    },
    mixins: [error, repository],
    props: {
        dataAtual: { type: String, required: true },
        origem: { type: String, default: 'atendimento' },
    },
    watch: {
        'model.data'(data) {
            if (data) {
                this.loadAgendamentos()
            }
        }
    }
}
</script>